//#region src/components/DefaultSelectAnchor/DefaultSelectAnchor.module.css
var e = "_icon_4muai_1", t = "_button_4muai_5", n = "_activeButton_4muai_14", r = {
	icon: e,
	button: t,
	activeButton: n
};
//#endregion
export { n as activeButton, t as button, r as default, e as icon };
